import { ObjectRule } from '@/classes/rules/ObjectRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';
import { ScenarioStructureFinanceExt } from '@/classes/scenario/ren-fr/structure-finance/ScenarioStructureFinanceExt';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';
import { BooleanRule } from '@/classes/rules/BooleanRule';

export const buildStructureFinanceRules = () => new ObjectRule<ScenarioStructureFinanceExt>('structure_finance', [
  new BooleanRule('crowdfunding'),
  new BooleanRule('linearDepreciationParticipative'),
  new MinMaxRule('percentageOfCapex'),
  new BooleanRule('coShareholder1'),
  new MinMaxRule('percentageOwnershipCoShareholder1'),
  new BooleanRule('coShareholder2'),
  new MinMaxRule('percentageOwnershipCoShareholder2'),
  new MinMaxRule('perRenSoldFarmDown')
])
  .withIsAvailable(scenario => isRenFranceProject(scenario))
  .withDefaultValue(() => new DefaultValue(new ScenarioStructureFinanceExt()));

function isRenFranceProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_pv_project || scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}
